import { useEffect, useState } from 'react';
import ChalkboardBackground from './ui/ChalkboardBackground';
import './LoadingScreen.css';

export default function LoadingScreen({ onComplete }) {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    // Set body background to dark immediately to prevent white flash
    const body = document.body;
    body.classList.remove('loaded');
    body.style.backgroundColor = '#1b1b1b';
    body.style.transition = 'background-color 0.8s ease';
    
    const timer = setTimeout(() => {
      setIsFading(true);
      // Start fading body to white as loading screen fades
      setTimeout(() => {
        body.classList.add('loaded');
      }, 200);
      
      // Wait for fade animation to complete before calling onComplete
      setTimeout(() => {
        setIsVisible(false);
        // Small delay to ensure fade completes before unmounting
        setTimeout(() => {
          onComplete();
        }, 100);
      }, 600); // Wait for fade out animation
    }, 2000); // Show for 2 seconds

    return () => {
      clearTimeout(timer);
    };
  }, [onComplete]);

  if (!isVisible) {
    return (
      <div className={`loading-screen-exit ${isFading ? 'fade-out' : ''}`} />
    );
  }

  return (
    <ChalkboardBackground className={`loading-screen ${isFading ? 'fade-out' : ''}`}>
      {/* Main content */}
      <div className="loading-content">
        {/* Logo/Text */}
        <div className="loading-text">
          <h1 className="loading-title">
            Blush & Bobby
          </h1>
          <p className="loading-subtitle">
            Loading...
          </p>
          <div className="loading-dots">
            <div className="dot dot-1"></div>
            <div className="dot dot-2"></div>
            <div className="dot dot-3"></div>
          </div>
        </div>
      </div>
    </ChalkboardBackground>
  );
}
